import {Fragment, useEffect, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {XMarkIcon} from '@heroicons/react/24/outline'
import AuthServices from "../../../../services/Auth.services";
import AddProductToQuotation from "./AddProductToQuotation";
import ToastService from "../../../../services/Toast.Service";

export default function AddProductToQuotationOverlay({
                                                         jwtToken,
                                                         loggedIn,
                                                         open,
                                                         variant,
                                                         handleCancelAction,
                                                         handleAcceptAction,
    userInfo,
    allowRedirect = true
                                                     }) {
    const [product, setProduct] = useState(null);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [allImages, setAllImages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const closeAction = () => {
        handleCancelAction();
    }

    useEffect(() => {
        if (!variant) {
            return;
        }

        setIsLoading(true);
        fetchVariant();
    }, [variant]);


    useEffect(() => {
        if (!variant) {
            return;
        }
        fetchImage();

    }, [selectedVariant]);

    const acceptAction = () => {
        handleAcceptAction();
    }

    const fetchVariant = async () => {

        let headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Content-Type", "application/json");

        if (jwtToken) {
            headers.append("Authorization", "Bearer " + jwtToken);
        }

        const data = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/products/" +
            variant,
            {
                method: "get",
                headers: headers,
            }
        ).then((response) => response.json());

        setSelectedVariant(data);
        setProduct(data);
        setIsLoading(false);
    }

    const fetchImage = async () => {
        let images = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/products/images/" +
            selectedVariant?.vitemId +
            "?single=0",
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        ).then((response) => response.json());

        if (images?.length > 0) {
            const uniqueImages = images.reduce((acc, image) => {
                if (!acc.find((img) => img.uid === image.uid)) {
                    acc.push(image);
                }
                return acc;
            }, []);

            setAllImages(uniqueImages);
            return;
        }
    };

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeAction}>
                <div className="fixed inset-0"/>

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                        <div className="px-4 sm:px-6">
                                            <div className="flex items-start justify-between">
                                                <Dialog.Title
                                                    className="text-base font-semibold leading-6 text-gray-900">
                                                    <div className="space-y-0 text-sm">
                                                        <p>{selectedVariant?.name}</p>
                                                        <p>{selectedVariant?.dimension}</p>
                                                    </div>
                                                </Dialog.Title>
                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                                        onClick={() => closeAction()}
                                                    >
                                                        <span className="absolute -inset-2.5"/>
                                                        <span className="sr-only">Close panel</span>
                                                        <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                            {!isLoading &&
                                                <AddProductToQuotation
                                                    jwtToken={jwtToken}
                                                    variant={selectedVariant}
                                                    loggedIn={loggedIn}
                                                    userInfo={userInfo}
                                                    product={product}
                                                    allImages={allImages}
                                                    allowRedirect={allowRedirect}
                                                    handleCancelAction={closeAction}
                                                />
                                            }

                                            {isLoading &&
                                                <div
                                                    className="border border-blue-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
                                                    <div className="animate-pulse flex space-x-4">
                                                        <div className="rounded-full bg-slate-700 h-10 w-10"></div>
                                                        <div className="flex-1 space-y-6 py-1">
                                                            <div className="h-2 bg-slate-700 rounded"></div>
                                                            <div className="space-y-3">
                                                                <div className="grid grid-cols-3 gap-4">
                                                                    <div
                                                                        className="h-2 bg-slate-700 rounded col-span-2"></div>
                                                                    <div
                                                                        className="h-2 bg-slate-700 rounded col-span-1"></div>
                                                                </div>
                                                                <div className="h-2 bg-slate-700 rounded"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
